import { email } from "@/utils/validators";

export const rules = {
  required: (v) => !!v || "Item required",
  email: (v) => email(v) || "Invalid Email",
};

export default {
  data() {
    return {
      rules: {
        required: (v) => !!v || "Item required",
        email: (v) => email(v) || "Invalid Email",
      },
    };
  },
};
